import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import withPackages from '../containers/withPackages';
import Styles from './footer.module.scss';

const Footer = props => (
  <footer data-role="footer-container">
    {(props.location.pathname !== '/update_email' && props.location.pathname !== '/account_details' &&
      props.location.pathname !== '/declined' && props.location.pathname.indexOf('/ads') !== 0 && !props.packages.activeIsFree) ?
        <center><p className={`small ${Styles.taxesfooter}`}>*Taxes may apply</p></center> : null}
  </footer>
);

Footer.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  packages: PropTypes.shape({
    activePackage: PropTypes.object.isRequired,
    activeIsFree: PropTypes.bool.isRequired,
  }).isRequired,
};


export default withRouter(withPackages(Footer));



// WEBPACK FOOTER //
// ./src/components/Footer.jsx